<div class="tooltip-container" >
    <div class="tooltip-content">
       <div class="content-wrapper">
            <div class="header">
                <div class="body-background" *ngIf="courseTypeImg; else shimmerEffect"
                [ngStyle]="{
                    'background': 'linear-gradient(to bottom, rgba(30, 33, 37, 0) 0, rgba(30, 33, 37, 2.8) 180px, rgba(30, 33, 37, 1) 290px), url(' + courseTypeImg + ') no-repeat center/cover'
                  }">                 <div class="trashCan">
                    <img (click)="openSuppModal()" src="../../../../../assets/images/trashCan.svg" alt="trashCan">
                 </div>
                <span class="title">Cours de {{data.tooltipData.clubName}}</span>
                <span class="description">Détails du cours</span>
                </div> 

                <ng-template #shimmerEffect>
                    <div class="body-background shimmer">
                        <div class="trashCan">
                            <img src="../../../../../assets/images/trashCan.svg" alt="trashCan">
                        </div>
                        <span class="title">Cours de {{tooltipData.clubName}}</span>
                        <span class="description">Détails du cours</span>
                    </div> 
                    
                </ng-template>

            </div>

            <div class="body">
              <div class="card-wrapper">

                <div class="info-wrapper">
                   <div class="icon">
                     <img src="../../../../../assets/icons/calendar-icon.svg" alt="calendar-icon">
                   </div>
                   <div class="info">
                      <span class="thick-text">{{ formatDateString(tooltipData.courseDate ) }} </span>
                      <span class="thin-text"> {{tooltipData.startTimeCourse}} - {{tooltipData.endTimeCourse}}</span>
                   </div>
                   <div class="duration">
                    <span class="duration-text">
                      {{ formatDuration(tooltipData.courseDurationMinutes) }}
                    </span>
                  </div>
                  
                  
                  
                  
                </div>

                <div class="divider"></div>

                <div class="info-wrapper">
                    <div class="icon">
                      <img src="../../../../../assets/icons/location-icon.svg" alt="location-icon">
                    </div>
                    <div class="info">
                       <span class="thin-text"> Localisation </span>
                       <span class="thick-text"> {{tooltipData.location}} </span>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="info-wrapper">
                    <div class="icon">
                      <img src="../../../../../assets/icons/instructor-icon.svg" alt="instructor-icon">
                    </div>
                    <div class="info">
                       <span class="thin-text"> Instructeur de cours </span>
                       <span class="thick-text"> {{tooltipData.coachName}} </span>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="info-wrapper participant-list" (click)="onParticipantListClick()" *ngIf="tooltipData.reservationNumber > 0">
                    <div class="icon">
                      <img src="../../../../../assets/icons/participant-icon.svg" alt="participant-icon">
                    </div>
                    <div class="info">
                       <span class="thin-text"> Liste des participants </span>
                       <span class="thick-text"> {{tooltipData.reservationNumber}} </span>
                    </div>
                    <div class="fleche">
                        <img src="../../../../../assets/icons/flech-icon.svg" alt="fleche-icon">
                    </div>
                </div>

                <div class="info-wrapper" *ngIf="tooltipData.reservationNumber === 0">
                    <div class="icon">
                      <img src="../../../../../assets/icons/participant-icon.svg" alt="participant-icon">
                    </div>
                    <div class="info">
                       <span class="thin-text"> Liste des participants </span>
                       <span class="thick-text"> {{tooltipData.reservationNumber}} </span>
                    </div>
                </div>
              </div>      
            </div>
 
        </div> 
 
       <div class="footer">
        <button class="update-option" >
           <span class="update-text" (click)="openCourseModif()">Modifier le cours</span> 
        </button>
       </div>
   
    </div>    
</div>

 
